import { createAsyncThunk } from '@reduxjs/toolkit';
// You should have a productsService similar to kpiService
import { productsService } from '../../../services/src/service/analytics/metadata.service';
import { MetadataActionTypes } from './types';

export const metadataActions = {
  getProductsMetadata: createAsyncThunk(
    MetadataActionTypes.FetchProductsRequest,
    async ({ shopId }: { shopId: number }, { rejectWithValue }) => {
      try {
        const response = await productsService.getProductsMetadata({ shopId });
        return response;
      } catch (error) {
        return rejectWithValue({ error });
      }
    }
  ),
};
